export enum LogLevel {
  Emergency = 'emerg',
  Alert = 'alert',
  Critical = 'crit',
  Error = 'err',
  Warning = 'warn',
  Notice = 'notice',
  Information = 'info',
  Debug = 'debug',
}

export class LogLevelMetadata {
  public label: string;
  public index: number;
  public color: string;

  constructor(label: string, index: number, color: string) {
    this.label = label;
    this.index = index;
    this.color = color;
  }
}

export class UserLog {
  public Id!: number;
  public Category!: string;
  public Fields!: any;
  public Level!: LogLevel;
  public Service!: UserLogService;
  public Time!: Date;
  public Message!: string;
  public Original!: string;
}

export class UserLogService {
  public Name: string;
  public Uid: number;

  constructor(name: string, uid: number) {
    this.Name = name;
    this.Uid = uid;
  }

  public get Label() {
    return `${this.Name} [${this.Uid}]`;
  }
}
